import { Link } from 'react-router-dom';
import { brandAssets, type LogoVariant } from '@/assets/brand';

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  linkToHome?: boolean;
}

const sizeClasses = {
  sm: 'w-40 sm:w-44',
  md: 'w-48 sm:w-56 md:w-60',
  lg: 'w-52 sm:w-60 md:w-64',
};

const wrapperClasses: Record<LogoVariant, string> = {
  light: '',
  dark: 'rounded-lg bg-background-50/95 backdrop-blur-sm px-2 py-0.5 shadow-sm ring-1 ring-background-200/80',
};

const Logo = ({ variant = 'light', className = '', size = 'md', linkToHome = true }: LogoProps) => {
  const image = (
    <img
      src={brandAssets.logo}
      alt="BitNinja Technologies"
      className={`block h-auto object-contain object-left shrink-0 ${sizeClasses[size]} ${className}`}
      width={1141}
      height={321}
      decoding="async"
      fetchPriority="high"
    />
  );

  const content = (
    <span className={`inline-flex items-center shrink-0 ${wrapperClasses[variant]}`}>
      {image}
    </span>
  );

  if (!linkToHome) {
    return content;
  }

  return (
    <Link to="/" className="inline-flex cursor-pointer" aria-label="BitNinja Technologies home">
      {content}
    </Link>
  );
};

export default Logo;
